import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { AdminWrap, BtnItem, Row } from '../../../../style/basic/commonStyle';
import { useParams } from 'react-router';
import BasicText from '../../../basic/BasicText';
import { useAdminUser } from '../../../../utils/custom-hooks/common/useAdminUser';
import { Grid } from '@mui/material';
import AdminAirportDetailUserPart from '../part/AdminAirportDetailUserPart';
import AdminAirportDetailContentPart from '../part/AdminAirportDetailContentPart';
import { addTheme } from '../../../../style/addTheme';
import { apiGetAdminAirportDetail, apiSetAdminAirportDetailUpdate } from '../../../../api/api_adm_airportAndParking';

export default function AdminAirportDetailPage() {
    const {id} = useParams();
    const adminUser = useAdminUser();
    const [info,setInfo] = useState<any>();

    useEffect(()=>{
        if(adminUser.admin_id === 0) return;
        getInfo();
    },[adminUser.admin_id])

    const getInfo = async() =>{
        const res = await apiGetAdminAirportDetail(adminUser.admin_token,adminUser.admin_id,id);
        if(res.result){
            setInfo(res.data);
        }
    }
    const valueChange = (name:string,val:any) =>{
        setInfo((obj:any)=>({
            ...obj,
            [name]: val,
        }))
    }
    const update = async() =>{
        const res = await apiSetAdminAirportDetailUpdate(adminUser.admin_token,adminUser.admin_id,id,info?.order_pickup_status,info?.order_pickup_memo);
        if(res.result){
            alert('변경 되었습니다.');
        }else{
            alert(res.error);
        }
    }
    return (
        <Wrap>
            <AdminWrap marginTop={0}>
                <BasicText fontSize={19} mFontSize={16} fontWeight={700}>예약 정보</BasicText>
                <InnerWrap>
                    <Grid container={true} spacing={4}>
                        <Grid item md={6} xs={12}>
                            <AdminAirportDetailUserPart info={info} valueChange={valueChange} />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <AdminAirportDetailContentPart info={info} />
                        </Grid>
                    </Grid>
                </InnerWrap>
                <BtnWrap>
                    <BtnItem bg={addTheme.infoChangeBtnBg} onClick={update}>정보 변경</BtnItem>
                </BtnWrap>
            </AdminWrap>
        </Wrap>
    )
}

const Wrap = styled.div``;
const InnerWrap = styled.div`
    margin-top: 35px;
`;
const BtnWrap = styled(Row)`
    justify-content: end;
    margin-top: 45px;
`;
